/**
 * File upload for form fields with file type
 * NOTE: versionFieldId changed to string to support UUID field IDs
 */
export class CaseFileUploadEntity {
  public versionFieldId!: string;
  public fileName!: string;
  public filePath!: string;
  public fileSizeBytes!: number;
  public contentType!: string;
}
